export default {
  methods: {
    resetValidation() {
      if (this.$v) {
        this.$v.$reset();
      }
    },

    async validateForm(done, storeName) {
      if (!this.$v) {
        this.$store.commit(storeName + '/setIsValid', true);
        done();
        return;
      }
      await this.validate()
        .then(() => this.$store.commit(storeName + '/setIsValid', true))
        .catch(() => this.$store.commit(storeName + '/setIsValid', false))
        .finally(() => {
          done();
        });
    },

    async validate() {
      return new Promise((resolve, reject) => {
        this.$v.$touch();
        if (this.$v.$invalid) {
          reject(new Error('validation failed'));
        } else {
          resolve();
        }
      });
    }
  },

  created() {
    this.$eventHub.$on('resetValidation', () => {
      this.resetValidation();
    });
  }
};
